module.exports = __webpack_public_path__ + "static/logos-ae85388b19666dd9676e4e69b215d497.png";